<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" class="pb-8">
        <v-row align="center">
          <v-col cols="auto" class="py-0 pr-0">
            <v-tooltip color="transparent" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="refresh"
                  v-on="on"
                  :disabled="loading"
                  class="glow mr-2"
                  color="primary"
                  x-small
                  fab>
                  <v-icon> refresh </v-icon>
                </v-btn>
              </template>
              <v-card class="elevation-2 px-2 py-1">
                <small>{{ $t('refreshData') }}</small>
              </v-card>
            </v-tooltip>
          </v-col>
          <v-col cols="10" class="py-0 pl-2">
            <p class="mt-2 mb-0">{{ $t('generated') }}: {{ dateString }}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col cols="12" sm="6">
        <CardStat
          :loading="loading"
          :value="`${entity.max_legend_bonus}%`"
          :text="$t('entities.maxBonuses.attributes.maxLegendBonus')" />
      </v-col>
      <v-col cols="12" sm="6">
        <CardStat
          :loading="loading"
          :value="`${entity.max_rank_bonus}%`"
          :text="$t('entities.maxBonuses.attributes.maxRankBonus')"
          color="orange"
          width="100px" />
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col cols="12" sm="6">
        <CardStat
          :loading="loading"
          :value="`${entity.max_reward_bonus}%`"
          :text="$t('entities.maxBonuses.attributes.maxRewardBonus')" />
      </v-col>
      <v-col cols="12" sm="6">
        <CardStat
          :loading="loading"
          :value="`${entity.max_subscription_bonus}%`"
          :text="$t('entities.maxBonuses.attributes.maxSubscriptionBonus')"
          color="orange"
          width="100px" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import CardStat from '@/components/CardStat.vue'
import MaxBonuses from '@/models/configuration/MaxBonuses'

import formatDate from '@/mixins/format-date'

export default Vue.extend({
  components: {
    CardStat,
  },

  mixins: [formatDate],

  data: () => ({
    dateString: null,
    loading: false,
    entity: {
      max_legend_bonus: 0,
      max_rank_bonus: 0,
      max_reward_bonus: 0,
      max_subscription_bonus: 0,
    },
  }),

  computed: {
    formTitle() {
      return this.$t(`entities.maxBonuses.editEntity`)
    },
  },

  mounted() {
    this.refresh()
  },

  methods: {
    ...mapActions(['showSnackbar']),

    async fetchMaxBonuses() {
      try {
        this.loading = true
        const response = await MaxBonuses.api.get()
        const data = response.data
        this.entity.max_legend_bonus = data.max_legend_bonus
        this.entity.max_rank_bonus = data.max_rank_bonus
        this.entity.max_reward_bonus = data.max_reward_bonus
        this.entity.max_subscription_bonus = data.max_subscription_bonus
      } catch (e) {
        console.warn(`Max Bonuses API failed.`)
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    refresh() {
      this.fetchMaxBonuses()
      this.dateString = this.formatDate(new Date(), true, true)
    },
  },
})
</script>
